// last ok "tabulator-tables": "^5.5.2",
import * as React from 'react';
import { useTheme } from '@mui/material/styles';

import {darken, lighten, alpha} from "@mui/material";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import Bs4Dialog from '../Bs4Components/Bs4Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';

import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4I18N from '../Bs4I18N';
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';
import * as Bs4Columns from './Bs4Columns'
import { getBoxSx, getBoxStyle, UXTEMPLATE, UxAccordion, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';
import Bs4ReportTabulatorUx, { TYPE_BS4REPORTTABULATOR } from '../Bs4Theme/Bs4UxTemplateEditors/Bs4ReportTabulatorUx';

export default class Bs4ReportTabulator extends Bs4ReportGeneric {
  static bs4ElementExpand = 'bs4ElementExpand';
  static bs4ButtonExpand = 'bs4ButtonExpand';

  createModel() {
    this.bs4ReportTabulatorUx = new Bs4ReportTabulatorUx(this.props.optionType, this.getPageParam(UXTEMPLATE), this.optionId);
    super.createModel();    
    this.autobs4width = Boolean(this.getPageParam('autobs4width'));        
  }
  
  setUxTemplate = (id) => {
    if (!id) id = this.getPageParam(UXTEMPLATE);
    this.bs4ReportTabulatorUx.setUxTemplate(id);
  }

  getUxTemplateEditor = (uxEditor) => {
    return this.bs4ReportTabulatorUx.getUxTemplateEditor(uxEditor);
  }

  getBoxSxTabulator = (theme, smallScreen) => {
    const reportTabulator = this.bs4ReportTabulatorUx.uxTemplate?.body?.ReportTabulator;
    const boxSx = getBoxSx(reportTabulator?.table, theme);
    const boxSxRow = getBoxSx(reportTabulator?.row, theme);
    const boxSxHeader = getBoxSx(reportTabulator?.header, theme);
    const boxSxGroup = getBoxSx(reportTabulator?.group, theme);
    const boxSxVerticalLine = getBoxSx(reportTabulator?.verticalLine, theme);
    const boxSxCell = getBoxSx(reportTabulator?.cell, theme);

    if (smallScreen) {
      boxSx.padding = 0;
      boxSx.margin = 0;

      boxSxHeader.padding = '8px 0px 8px 0px';
      boxSxHeader.margin = 0;

      boxSxRow.padding = '8px 0px 8px 0px';
      boxSxRow.margin = 0;
      delete boxSxRow.minHeight;

      boxSxGroup.padding = '8px 0px 8px 0px';
      boxSxGroup.margin = 0;      

      delete boxSxCell.padding;
      delete boxSxCell.margin;
      delete boxSxCell.minHeight;
    }

    const sx = {...boxSx,
      '.tabulator': {
        '.tabulator-header': {
          ...boxSxHeader,                
        },              
        '.tabulator-row': {
          ...boxSxRow,
          '.tabulator-cell': {
            ...boxSxCell,
          }, 
          '.tabulator-data-tree-branch': {
            borderColor: boxSxRow.color || boxSxCell.color || '#00000088',
          },
        },  
        '.tabulator-group': {
          ...boxSxGroup,
        },
        '.tabulator-col-resize-handle': {
          ...boxSxVerticalLine,
        }
      },            
    };
    
    return sx;
  }

  triggerTabulatorBuiltArry = [];
  triggerTabulatorBuilt = (built) => {    
    this.triggerTabulatorBuiltArry.forEach(trigger => trigger(built))
    this.triggerTabulatorBuiltArry = [];
  } 

  bs4ColumnsDef = new Map();

  getColumns (colDef) {
    // console.log('...columns..colDef.', colDef)
    this.bs4ColumnsDef.clear();
    let columns = [];
    if (Array.isArray(colDef)) {     
      this.columnsObj = {}
      columns = colDef.map(column => {
        // console.log('...getColumns...', column.text, column)
        this.bs4ColumnsDef.set(column.dataIndex, column)
        const columnT = Bs4Columns.getColumn(column, this);
        columnT.cellClick = (e, cell) => {
          //Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId);
        };        
        //columnT.headerWordWrap = true;
        this.columnsObj[columnT.field] = columnT;
        return columnT;
      });
    }

    if (this.autobs4width) {      
      let minWidth = null;
      columns = columns.map(column => {
        column.width = parseInt(column.width);
        if (isNullOrNaN(column.width)) column.width = 0;        
        if (column.width > 0) {
          minWidth = Math.min(minWidth || column.width, column.width);
        }
        return column;
      })

      minWidth = Math.max(minWidth, 1);

      columns = columns.map(column => {        
        column.widthGrow = column.width / minWidth;
        column.widthShrink = minWidth / Math.max(column.width, 1);
        delete column.width;
        return column;
      })
    }

    if (Boolean(this.bs4ColExpnd)) {
      const printIcon = (cell, formatterParams) => {
        if (cell.getValue() === 'block') {
          return '<i class="fa-regular fa-angle-up" ></i>';
        }
        return '<i class="fa-regular fa-angle-down"></i>';  
      };

      const cellClick = (e, cell) => {        
        const bs4ElementExpand = cell.getRow().getData()[Bs4ReportTabulator.bs4ElementExpand];
        if (bs4ElementExpand) {
          const display = bs4ElementExpand.style.display === 'block' ? 'none' : 'block';
          bs4ElementExpand.style.display = 'none';            
          cell.getRow().update({[Bs4ReportTabulator.bs4ButtonExpand]: display})
          .then(() => {          
            bs4ElementExpand.style.display = display;
          })
          .catch(error => {
            console.log('...updateRow error', error);
            //ResizeObserver.disconnect()
          });
        }                            
      }

      const expanderColumn = {field: Bs4ReportTabulator.bs4ButtonExpand, formatter: printIcon, width: 40, hozAlign: "center", cellClick: cellClick}
      columns = [expanderColumn, ...columns];
    }   
    
    if (this.selectableCheckbox) {
      //!! resizable: false - inaczej błąd
      const selectColumn = {
        formatter: "rowSelection", 
        titleFormatter: "rowSelection", 
        hozAlign: "center", 
        headerSort: false, 
        frozen: true, 
        resizable: false,
        widthGrow: -1,
        widthShrink: -1,
        titleFormatterParams:{
          rowRange: "active" //only toggle the values of the active filtered rows
        }
      }; 
      columns = [selectColumn, ...columns];
    }

    if (this.getPageParam('allowdragdrop')) {
      //<i class="fa-solid fa-grip-dots"></i>
      //{rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
      // console.log('...allowdragdrop...', this.constructor.name)
      const movableColumn = {
        rowHandle: true,
        //formatter:"handle", 
        formatter: Bs4Columns.formatterHandle, 
        //titleFormatter:"rowSelection", 
        //hozAlign:"center", 
        headerSort:false, 
        frozen:true, 
        resizable: false,
        widthGrow: -1,
        widthShrink: -1,
      }; 
      columns = [movableColumn, ...columns];
    }    
    
    //console.log('...Tabulator...columns...', columns);
    if (Array.isArray(columns)) return columns;
    return [];    
  }

  getData() {
    return this.tabulator.getData();
  }
  
  fetchCriteriaVals(tableBuilt) {
		const filterCriteria = this.defaultCriteriaVals();    
				
		if (this.remembersettings) { //pamiętaj układ
		  filterCriteria.remembersettings = 1;
		}	

    if (tableBuilt) {
		  filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
    }
    
		return filterCriteria;
	}

  packColumnLayout() {    
    if (!this.tableBuilt) return null;
    let groupByColumn = null;
    const group = this.getGroupBy();
    if (group) groupByColumn = group.getField();
    const tablica = this.tabulator.getColumnLayout().filter(column => Boolean(column.field)).map((column, index) => {    
      return {
        dataIndex: column.field, 
        groupbyc: (groupByColumn === column.field) ? 1 : 0,
        hidden: !column.visible,
        id: column.field,
        index: index + 1,
        width: column.width,
      }
    })
    return JSON.stringify(tablica);
  }

  tabulator = null;
  tableBuilt = false;
  dataProcessing = false;
  tabulatorLangs = {
    "pl-PL":{
      "columns":{
        "name":"Nazwa", //replace the title of column name with the value "Name"
      },
      "data":{
        "loading":"Wczytywanie", //data loader text
        "error":"Błą", //data error text
      },
      "groups":{ //copy for the auto generated item count in group header
        "item":"pozycja", //the singular  for item
        "items":"pozycje", //the plural for items
      },
      "pagination":{
        "page_size":"Wierszy na stronie", //label for the page size select element
        "page_title":"Pokaż stronę",//tooltip text for the numeric page button, appears in front of the page number (eg. "Show Page" will result in a tool tip of "Show Page 1" on the page 1 button)
        "first":"<<", //text for the first page button
        "first_title":"Pierwsza strona", //tooltip text for the first page button
        "last":">>",
        "last_title":"Ostatnia strona",
        "prev":"<",
        "prev_title":"Poprzednia strona",
        "next":">",
        "next_title":"Następna strona",
        "all":"All",
        "counter":{
          "showing": "Wyświetlono",
          "of": "z",
          "rows": "wierszy",
          "pages": "stron",
        }
      },
      "headerFilters":{
        "default":"filtr kolumna...", //default header filter placeholder text
        "columns":{
          "name":"filtr nazwa...", //replace default header filter text for column name
        }
      }
    },
  };

  getSelectedIdArray() {
    return this.tabulator.getSelectedData().map(row => row.id);
  }
  
  gridSortToHidden() {
    const sortersObj = {
      direction: null,
      property: null,
      root: "data"
    }
    const sorters = this.tabulator.getSorters()[0];    
    if (sorters) {
      sortersObj.direction = sorters.dir;
      sortersObj.property = sorters.field
    }
    return sortersObj;
  }

  bs4Totals = null;
  
  getTopRow = () => {
    let colRect = null;
    let rowIndex = null;

    for (const col of this.tabulator.getColumns()) {
      colRect = col.getElement().getBoundingClientRect();
      break; 
    }

    for (const row of this.tabulator.getRows()) {
      const rowRect = row.getElement().getBoundingClientRect();
      if (colRect.bottom < rowRect.bottom) {
        rowIndex = row.getIndex();
        break; 
      }      
    }

    return rowIndex;
  }

  
  reload = (position) => {
    this.bs4PageProps.counter = 0;
    clearTimeout(this.autoGridReloadEveryTimeout);
    if (!this.tabulator) return;
    let scrollTop = null;
    try {
      if (this.refTabulator) scrollTop = this.refTabulator?.current?.children?.item(1)?.scrollTop;
    } catch (error) {
      console.log('...reload.scroll.error.1..', error);
    }
    // 2024-01-12 zlec: 1550 – Akcja "Odśwież w zestawieniu wiersz z opcją" [Core]
    // let rowIndex = position ? this.getTopRow() : null;
    // let rowIndex = this.getTopRow();    
    const currentPabeNumber = this.tabulator.getPage();
    this.tabulator.setPage(currentPabeNumber)
    .then(() => {            
      // if (rowIndex) this.tabulator.scrollToRow(rowIndex - 1)
      try {
        const box = this.refTabulator?.current?.children?.item(1);
        if (scrollTop && box) box.scrollTop = scrollTop;
        const max = this.tabulator.getPageMax();
        if (max < currentPabeNumber) this.tabulator.setPage(max)
        // console.dir(box);
      } catch (error) {
        console.log('...reload.scroll.error...', error);
      }
      this.autoGridReloadEvery();
    })
    .catch(error => {
      console.log(error)
      this.autoGridReloadEvery();
    });
  }

  autoGridReloadEvery = () => {
    clearTimeout(this.autoGridReloadEveryTimeout);
    const reloadEvery = parseInt(this.getPageParam('autoGridReloadEvery'));    
    if (reloadEvery > 0) {
      this.autoGridReloadEveryTimeout = setTimeout(() => {
        try {
          this.reload();
          // this.reload() uruchomi kolejną iteracje autoGridReloadEvery.
          //this.autoGridReloadEvery();
        } catch(error) {
          console.log('...autoGridReloadEvery...', error);
        }            
      }, reloadEvery * 1000);
      // }, 5 * 1000);
    }
  }    
  
  footerElement = () => {   
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    const param = "'"+this.bs4KartotekaId+"', "+this.optionId;

    window.bs4FooterPokaz = (bs4KartotekaId, optionId) => {
      const bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
      const bs4Option = bs4Kartoteka.getBs4Option(optionId);
      bs4Option.bs4FooterPokaz();
    }

    window.bs4FooterPamietaj = (bs4KartotekaId, optionId) => {      
      const bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
      const bs4Option = bs4Kartoteka.getBs4Option(optionId);
      bs4Option.bs4FooterPamietaj();
    }

    window.bs4FooterResetuj = (bs4KartotekaId, optionId) => {
      const bs4Kartoteka = Bs4Kartoteka.get(bs4KartotekaId);
      const bs4Option = bs4Kartoteka.getBs4Option(optionId);
      //console.log('...window.bs4FooterResetuj... ', bs4KartotekaId, optionId, bs4Kartoteka, bs4Option)
      bs4Option.bs4FooterResetuj();
    }
    
    bs4Option.bs4FooterPokaz = () => {
      this.remembersettings = false;
      this.reload();
    }

    bs4Option.bs4FooterPamietaj = () => {      
      this.remembersettings = true;
      this.reload();
    }

    bs4Option.bs4FooterResetuj = () => {
      this.remembersettings = false;
      // ajax zapominajacy
      Bs4MainDispatch.commandParser('Bs4PrefsReset', {js_ForgetOptionId: this.optionId }, this.bs4KartotekaId); 
      this.clearAllCriteria();      
      this.reload();
    }

    const footer = 
      '<button onclick="bs4FooterPokaz('+param+')" class="tabulator-page" types="button" role="button" title="Pokaż" ><i class="fa-regular fa-arrows-rotate"></i></button>' +
      '<button onclick="bs4FooterPamietaj('+param+')" class="tabulator-page" types="button" role="button" title="Pamiętaj" ><i class="fa-regular fa-thumbtack"></i></button>' +
      '<button onclick="bs4FooterResetuj('+param+')" class="tabulator-page" types="button" role="button" title="Resetuj" ><i class="fa-regular fa-eraser"></i></button>' +
      '<span> &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp</span>';
    return footer;
  }

  groupHeader = (value, count, data, group) => {
    //value - the value all members of this group share
    //count - the number of rows in this group
    //data - an array of all the row data objects in this group
    //group - the group component for the group
    const boxSxGroup = getBoxSx(this.bs4ReportTabulatorUx.uxTemplate?.body?.ReportTabulator?.group, this.theme);
    const color = boxSxGroup.color || '#777777';
    console.log('...groupHeader...', value, count, data, group, '...', color);

    return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
  }

  rowFormatter = row => {    
    const data = row.getData();
    let backgroundColorSaved = null;
    try{
      const element = row.getElement()
      
      // 61021 – Kilka usprawnień do intuicyjności GUI (3.)
      if (this.targetField) {
        element.addEventListener("mouseleave", (event) => {
          element.style['backgroundColor'] = backgroundColorSaved;
        });
        element.addEventListener("mouseenter", (event) => {
          backgroundColorSaved = element.style['backgroundColor'];
          const backgroundColorHover = darken(backgroundColorSaved || '#ffffff', 0.1);
          element.style['backgroundColor'] = backgroundColorHover;
        });
      }

      const boxStyle = { 
        ...getBoxStyle(this.bs4ReportTabulatorUx.uxTemplate?.body?.ReportTabulator?.row, this.theme), 
        ...getBoxStyle(data.xx555, this.theme),  
        //textAlign: 'center',
        //display: 'flex',
        //justifyContent: 'center',
        //alignitems: 'center',
      };

      //console.log('..Tabulator Select ... ', boxStyle)
      
      if (this.lastCommandParserAfterRow && data.id && this.lastCommandParserAfterRow === data.id) {
        console.log('..Tabulator Select ID===id... ', boxStyle)
        //boxStyle.borderTop = '5px solid';
        //boxStyle.borderBottom = '5px solid';
        boxStyle.backgroundColor = darken(boxStyle.backgroundColor || '#ffffff', 0.1);
      } 
      //2023-08-28 1360 – Zestawienie - border on click [Core]      
      element.style['backgroundColor'] = null;

      for (const [key, value] of Object.entries(boxStyle)) {                
        if (key in element.style) element.style[key] = value;
      }
      
    } catch(error) {
      console.log('..error.. ', error)
    }
          
    if (Boolean(this.bs4ColExpnd) && String(this.bs4ColExpnd) in data) {
      let bs4ElementExpand = data[Bs4ReportTabulator.bs4ElementExpand];
      let bs4ElementExpandExists = false;
      for (const el of row.getElement().childNodes) {
        if (el === bs4ElementExpand) {
          bs4ElementExpandExists = true;
          break;
        }
      }

      if (!bs4ElementExpand) {              
        bs4ElementExpand = document.createElement("div");
        data[Bs4ReportTabulator.bs4ElementExpand] = bs4ElementExpand;
        bs4ElementExpand.style.boxSizing = 'border-box';
        bs4ElementExpand.style.padding = '0px 30px 0px 30px';
        bs4ElementExpand.style.whiteSpace = 'pre-wrap';
        bs4ElementExpand.style.display = 'none'
        bs4ElementExpand.innerHTML = data[this.bs4ColExpnd];              
      }

      if (!bs4ElementExpandExists) {
        row.getElement().appendChild(bs4ElementExpand);
      }
    }  
  }

  headerSortElement = (column, dir) => {
    //column - column component for current column
    //dir - current sort direction ("asc", "desc", "none")

    switch(dir) {
      case "asc":  return '<i class="fa-solid fa-arrow-down-short-wide"></i>';
      case "desc": return '<i class="fa-solid fa-arrow-up-wide-short"></i>'; 
      default:     return '<i class="fa-thin fa-arrow-up-arrow-down"></i>';
    }
  }

  TransitionColumns = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  getGroupBy = () => {      
    let group = null
    const groups = this.tabulator.getGroups();    
    if (Array.isArray(groups)) groups.forEach(g => {
      group = g;
    })   
    return group;
  }

  getSorterBy = () => {      
    const sorters = this.tabulator.getSorters();
    if (Array.isArray(sorters) && sorters.length > 0) return ({field: sorters[0].field, dir: sorters[0].dir});
    return {field: null, dir: null};
  }

  getSelectableCheckbox = (items) => {
    if (this.props.noSelectableCheckbox) return false;
    return this.getSelectableCheckboxItems(Bs4Kartoteka.get(this.bs4KartotekaId).getReportMenu(this.optionId));
  }

  getSelectableCheckboxItems = (items) => {
    if (this.props.noSelectableCheckbox) return false;
    for (const item of items || []) {
      if (item.selectRows) return true;
      if (Array.isArray(item.items)) {
        const selectableCheckbox = this.getSelectableCheckboxItems(item.items);
        if (selectableCheckbox) return true;
      }
    }
    return false;
  }

  addCss = () => {
    const range = document.createRange()
    const frag = range.createContextualFragment(`
    <style>
      .hover-danger:hover{
        background-color: red;
        font-weight: 900
      }
    </style>
    `
  )
    document.querySelector("head").append(frag)  
  }
  
  ViewColumns = (props) => {
    const bs4Report = this;
    const columnsTT = Bs4I18N.getTT('Kolumny', 'Kolumny', 'Bs4ReportTabulator');
    const okTT = Bs4I18N.getTT('Ok', 'Ok', 'Bs4ReportTabulator');
    this.theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [columns, setColumns] = React.useState(null);
    const [group, setGroup] = React.useState(null);
    const [sorter, setSorter] = React.useState({field: null, dir: null});
    const refHeader = React.useRef(null);

    const handleOpen = () => {
      setColumns(this.tabulator.getColumns());
      setOpen(true);
      setSorter(this.getSorterBy());
      setGroup(this.getGroupBy())
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleClick = (e, column) => {
      column.toggle();
      setColumns([...columns]);
    }    

    const handleChangeGroup = (e, column) => {
      if (column.getField() === group?.getField()) column.getTable().setGroupBy(null);
      else column.getTable().setGroupBy(column.getDefinition().field);
      setGroup(this.getGroupBy())
      this.reload();
    }        

    const handleChangeSurtAsc = (e, column) => {
      this.tabulator.setSort(column.getField(), "asc");
      setSorter(this.getSorterBy());
    }        

    const handleChangeSurtDes = (e, column) => {
      this.tabulator.setSort(column.getField(), "desc");
      setSorter(this.getSorterBy());
    }     
    
    const handleEditColumn = (e, column) => {
      const details = {
        targetObject: column.getField().replace('zx', ''), 
        targetOption: 468, 
        currCardViewId:bs4Report.bs4KartotekaId, 
        currOptionId:bs4Report.optionId
      }
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, bs4Report.bs4KartotekaId);
    }

    const handleGear = (event) => {
      console.log('...handleGear...', )      
      Bs4MainDispatch.commandParser('Bs4OpenCard', {targetObject: this.optionId, targetOption: 2000149}, this.bs4KartotekaId);
    }
    
    //if (!columns || columns.length === 0) return null;

    return (
      <React.Fragment>
        <IconButton onClick={handleOpen}>
          <i className="fa-solid fa-layer-group"></i>
        </IconButton>
        {columns ?
        <Bs4Dialog
          open={open}
          bs4KartotekaId={bs4Report.bs4KartotekaId}
          TransitionComponent={this.TransitionColumns}
          //keepMounted
          onClose={handleClose}
          refHeader={refHeader}
          hideBackdrop={true}
        >
          <DialogTitle ref={refHeader} sx={{touchAction: 'none'}}>
            <Stack width='100%' direction='row' justifyContent="space-between" sx={{cursor:'move'}}>
              <span><i className="fa-solid fa-layer-group"/>&nbsp;&nbsp;{columnsTT}</span>
              {bs4Report.props.bs4ConstructorMode.enabled ?
                <IconButton edge='end' onClick={handleGear}><i className="fa-solid fa-gear"/></IconButton>
              : null}
            </Stack>
          </DialogTitle>
          <DialogContent>
            <List sx={{bgcolor: 'background.paper'}}> 
              {/* maxWidth: '90%' */}
              {columns.map((column, index) => {
                if (!column.getDefinition().title) return;
                const bs4Column = this.bs4ColumnsDef.get(column.getField())
                const title = column.getDefinition().title;
                const checked = column.isVisible();
                const sortVisibility = column.getDefinition().headerSort ? 'visible' : 'hidden';
                const groupVisibility = bs4Column?.groupable ? 'visible' : 'hidden';
                return (
                  <ListItem key={index} disablePadding>
                    <ListItemButton onClick={(e) => handleClick(e, column)} dense>
                      <ListItemIcon>
                        <Checkbox
                          //edge="start"
                          checked={checked}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText primary={title} />                    
                    </ListItemButton>
                    <ListItemIcon sx={{display: bs4Report.props.bs4ConstructorMode.enabled ? 'block' : 'none'}}>
                      <IconButton onClick={(event) => handleEditColumn(event, column)}>
                        <i className='fa-solid fa-gear' title='Edit'></i>
                      </IconButton>
                    </ListItemIcon>
                    <ListItemIcon>
                      <Checkbox
                        //edge="start"
                        sx={{visibility: groupVisibility}}
                        checkedIcon={<i className="fa-solid fa-people-group"></i>}
                        icon={<i className="fa-thin fa-people-group"></i>}
                        checked={column.getField() === group?.getField()}
                        onChange={(e) => handleChangeGroup(e, column)}
                      />
                    </ListItemIcon>
                    <ListItemIcon>                    
                      <Checkbox
                        sx={{visibility: sortVisibility}}
                        //edge="start"
                        checkedIcon={<i className="fa-solid fa-arrow-down-short-wide"></i>} 
                        icon={<i className="fa-thin fa-arrow-down-short-wide"></i>}
                        checked={column.getField() === sorter.field && sorter.dir === 'asc'}
                        onChange={(e) => handleChangeSurtAsc(e, column)}
                      />
                    </ListItemIcon>
                    <ListItemIcon>
                      <Checkbox
                        sx={{visibility: sortVisibility}}
                        //edge="start"
                        checkedIcon={<i className="fa-solid fa-arrow-up-wide-short"></i>} 
                        icon={<i className="fa-thin fa-arrow-up-wide-short"></i>}
                        checked={column.getField() === sorter.field && sorter.dir === 'desc'}
                        onChange={(e) => handleChangeSurtDes(e, column)}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>         
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{okTT}</Button>
          </DialogActions>
        </Bs4Dialog>
        : null
        }
      </React.Fragment>
    )
  }

  ViewComponent = React.forwardRef((props, ref) => {
  });
}